{
  "domain": "recrewt-multiplicator-platform.eu.auth0.com",
  "clientId": "lSRStQZbgEv8ldsj9F3MWKVIp5zDMPAq",
  "audience": "https://recrewt-multiplicator-platform"
}
